import { Component, forwardRef, inject, OnInit, ViewChild } from '@angular/core'
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms'
import {
  IonicSelectableComponent,
  IonicSelectableHeaderTemplateDirective,
  IonicSelectableItemTemplateDirective,
  IonicSelectableValueTemplateDirective,
} from 'ionic-selectable'
import { IonicModule } from '@ionic/angular'
import { ClientService } from '../../../../services/domain/client/client.service'
import { AsyncPipe, NgIf } from '@angular/common'
import { Client } from '../../../../models/client'
import { searchFilter } from '../../../../services/utils'
import { BehaviorSubject, Observable } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'

@Component({
  selector: 'app-client-select',
  templateUrl: './client-select.component.html',
  styleUrls: ['./client-select.component.scss'],
  standalone: true,
  imports: [
    IonicSelectableComponent,
    IonicModule,
    AsyncPipe,
    NgIf,
    FormsModule,
    IonicSelectableComponent,
    IonicSelectableValueTemplateDirective,
    IonicSelectableHeaderTemplateDirective,
    IonicSelectableItemTemplateDirective,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ClientSelectComponent),
      multi: true,
    },
  ],
})
export class ClientSelectComponent implements OnInit, ControlValueAccessor {
  private clientsService = inject(ClientService)

  @ViewChild('selectableComponent')
  selectableComponent: IonicSelectableComponent

  private _value: number // clientId
  public disabled: boolean
  private _onChange: (value: number) => void
  protected _onTouched: () => void
  protected selectedItem: Client

  protected onSearch$$: BehaviorSubject<string> = new BehaviorSubject('')

  protected filteredClients$: Observable<Client[]> = this.clientsService.getActiveWithCaching().pipe(
    tap((clients) => (this.selectedItem = clients.find((c) => c.id === this._value))),
    switchMap((clients) =>
      this.onSearch$$.pipe(map((searchPhrase) => searchFilter(clients, searchPhrase, ['user.fullname']))),
    ),
  )

  ngOnInit() {}
  registerOnChange(fn: any): void {
    this._onChange = fn
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }
  writeValue(value: any): void {
    console.log(`clientId select value ${value}`)
    this._value = value
  }

  searchClients(text: string) {
    this.onSearch$$.next(text)
  }

  async closeClientSelect() {
    await this.selectableComponent.close()
  }

  protected readonly console = module

  itemSelected(event: { component: IonicSelectableComponent; value: Client }) {
    this._value = event.value.id
    this._onChange(this._value)
  }
}
